export const isMobile = () => window.outerWidth < 600 && true;
